export default {
    // 会员管理
    api_getUserQuestion: "/api/user/getUserQuestion", //获取用户提问

    // Mine
    api_getUserByUserId: "/api/mine/getUserByUserId", //获取会员详情
    api_userRegister: "/api/mine/userRegister", //会员初次注册
    api_userLogin: "/api/mine/userLogin", //会员系统登录
    api_updateUserPassword: "/api/mine/updateUserPassword", //会员修改密码
    api_updateUserPayPassword: "/api/mine/updateUserPayPassword", //修改支付密码
    api_updateUserInfo: "/api/mine/updateUserInfo", //修改会员资料
    api_refreshMoney: "/api/mine/refreshMoney",
    api_getMessage: "/api/mine/getMessage",
    api_getNotReadCount: "/api/mine/getNotReadCount",
    api_addBankWallet: "/api/mine/addBankWallet",
    api_deleteBankWallet: "/api/mine/deleteBankWallet",
    api_editBankWallet: "/api/mine/editBankWallet",
    api_getBankWallet: "/api/mine/getBankWallet",
    api_addDigitalWallet: "/api/mine/addDigitalWallet",
    api_deleteDigitalWallet: "/api/mine/deleteDigitalWallet",
    api_editDigitalWallet: "/api/mine/editDigitalWallet",
    api_getDigitalWallet: "/api/mine/getDigitalWallet",
    api_getRechargeConfig: "/api/mine/getRechargeConfig",
    api_recharge: "/api/mine/recharge",
    api_withdraw: "/api/mine/withdraw",
    api_completeRechargeInfo: "/api/mine/completeRechargeInfo",
    api_getOneRecharge: "/api/mine/getOneRecharge",
    api_getOneWithdraw: "/api/mine/getOneWithdraw",
    api_getSiteMessage: "/api/mine/getSiteMessage",
    api_readSiteMessage: "/api/mine/readSiteMessage",
    api_getOtherUserByUserId: "/api/mine/getOtherUserByUserId",
    api_getOneNotFinishWithdraw: "/api/mine/getOneNotFinishWithdraw",

    // Chat
    api_modifyGroupNameOrNotice: "/api/chat/modifyGroupNameOrNotice",
    api_getOneGroupUserByUserId: "/api/chat/getOneGroupUserByUserId",
    api_getOneGroup: "/api/chat/getOneGroup",
    api_removeFromGroup: "/api/chat/removeFromGroup",
    api_openCloseGroupSpeak: "/api/chat/openCloseGroupSpeak",
    api_getGroupUser: "/api/chat/getGroupUser",

    // Order
    api_getOrder:"/api/order/getOrder",
    api_getOneOrder:"/api/order/getOneOrder",
    api_cancelOrder:"/api/order/cancelOrder",

    // Asset
    api_findRecharge:"/api/asset/findRecharge",
    api_findWithdraw:"/api/asset/findWithdraw",
    api_findMoneyRecord:"/api/asset/findMoneyRecord",

    // Market
    api_findOneNowPriceGains:"/api/market/findOneNowPriceGains",
    api_findOnePriceHis:"/api/market/findOnePriceHis",
    api_findOnePriceKline:"/api/market/findOnePriceKline",
    api_betOrder:"/api/market/betOrder",
    
    // Home
    api_findNowPrice:"/api/home/findNowPrice",
    api_findNowPriceGains:"/api/home/findNowPriceGains",

    // 公告广告
    api_findBroadcasts: "/api/notice/findBroadcasts", //获取公告列表
    api_findOneBroadcast: "/api/notice/findOneBroadcast", //获取一条公告

    // 游戏管理
    api_turnOpen: "/api/game/turnOpen", // 转盘开奖
    api_findLastRed: "/api/game/findLastRed", // 最新红包数据
    api_grabRed: "/api/game/grabRed", // 拆红包

    // 基础配置
    api_findOneConfigById: "/api/config/findOneConfigById", //查询配置信息
    api_findLocalIp: "/api/config/findLocalIp", //查看本地IP
    api_findOneConfigByKeyName: "/api/config/findOneConfigByKeyName", //查询配置信息
    api_findConfigs: "/api/config/findConfigs", //查询多个配置信息
    api_findNotices:"/api/config/findNotices",
    api_findOneNotice: "/api/config/findOneNotice", //获取一条广告
};